import { useAuth } from '../../context/AuthContext';
import { ChevronDownIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .oh { height:60px; min-height:60px; background:#ffffff; border-bottom:1px solid #eaecf4; display:flex; align-items:center; justify-content:space-between; padding:0 24px; font-family:'Sora',sans-serif; flex-shrink:0; z-index:10; }
  .oh-left { display:flex; align-items:center; gap:8px; }
  .oh-breadcrumb { font-size:.8rem; color:#b0b5cc; }
  .oh-sep  { color:#d8dce8; font-size:.8rem; }
  .oh-page { font-size:.82rem; color:#1a1d2e; font-weight:600; }
  .oh-right { display:flex; align-items:center; gap:8px; }
  .oh-divider { width:1px; height:24px; background:#eaecf4; margin:0 4px; }
  .oh-user { display:flex; align-items:center; gap:10px; padding:5px 10px 5px 5px; border-radius:12px; cursor:pointer; transition:background .15s; border:1px solid transparent; }
  .oh-user:hover { background:#f5f6fb; border-color:#eaecf4; }
  .oh-avatar { width:32px; height:32px; border-radius:10px; background:linear-gradient(135deg,#7c3aed,#4f46e5); display:flex; align-items:center; justify-content:center; font-size:.75rem; font-weight:700; color:white; flex-shrink:0; }
  .oh-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .oh-role { font-size:.68rem; color:#9094a8; margin-top:2px; }
  .oh-user svg { width:14px; height:14px; stroke:#b0b5cc; stroke-width:2; margin-left:2px; }
  .oh-logout { padding:7px 14px; background:#f5f0ff; color:#7c3aed; border:1px solid #ddd6fe; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .oh-logout:hover { background:#ede9fe; }
  .oh-hamburger { display:none; width:36px; height:36px; border:none; background:transparent; cursor:pointer; }
  .oh-hamburger svg { width:20px; height:20px; stroke:#6b7194; stroke-width:1.7; }
  @media (max-width:768px) {
    .oh { padding:0 16px; }
    .oh-hamburger { display:flex; align-items:center; justify-content:center; }
    .oh-breadcrumb,.oh-sep { display:none; }
    .oh-name,.oh-role,.oh-user svg { display:none; }
    .oh-user { padding:4px; }
    .oh-divider { display:none; }
  }
`;

const getInitials = (name='') => name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)||'O';

export default function OwnerHeader({ onMenuClick }) {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Owner';
  return (
    <>
      <style>{css}</style>
      <header className="oh">
        <div className="oh-left">
          <button className="oh-hamburger" onClick={onMenuClick}><Bars3Icon /></button>
          <span className="oh-breadcrumb">School Portal</span>
          <span className="oh-sep">/</span>
          <span className="oh-page">Owner Panel</span>
        </div>
        <div className="oh-right">
          <div className="oh-user">
            <div className="oh-avatar">{getInitials(displayName)}</div>
            <div>
              <div className="oh-name">{displayName}</div>
              <div className="oh-role">School Owner</div>
            </div>
            <ChevronDownIcon />
          </div>
          <div className="oh-divider" />
          <button className="oh-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
}